import { FC } from 'react';
import { Contract } from '../../../models/contract';
import useNotyf from '../../../context/useNotify';
import { useUser } from '../../../context/useUser';
import ContractService from "../../../services/contract"
import HelperService from "../../../services/helper"
import styled from 'styled-components';
import placeholderImage from "../../../images/common/vgc-logo.png"
import { useLeague } from '../../../context/useLeague';
import UserService from '../../../services/user';


interface AcceptContractFormProps {
  contract: Contract;
  closeModal: () => void;
}

const AcceptContractForm: FC<AcceptContractFormProps> = ({ contract, closeModal }) => {
  const notfy = useNotyf();
  const { getLeagueById } = useLeague();
  const { user, tokenLogin } = useUser();

  const acceptContract = async () => {
    if (!user) {
      return;
    }
    try {
      await ContractService.updateContract(contract._id, { isAccepted: true });
      notfy.success("✅🏃‍♂️⚽ Contract accepted!");
      tokenLogin();

      // Fix: use league should be fetching this data
      const data = await UserService.readUser(user._id);
      if (data.user.leagues.length) {
        getLeagueById(data.user.leagues[0]);
      }
    } catch (err) {
      console.error(err);
      HelperService.showNotfyErr(notfy, err, "Error accepting contract");
    } finally {
      closeModal();
    }
  };

  const rejectContract = async () => {
    try {
      await ContractService.deleteContract(contract._id);
      notfy.success("❌ Contract rejected.");
      tokenLogin();
    } catch (err) {
      console.error(err);
      HelperService.showNotfyErr(notfy, err, "Error rejecting contract");
    } finally {
      closeModal();
    }
  };

  return (
    <div className="h-100 d-flex flex-column justify-content-center p-3">
      <div className="row px-5 px-2">
        <div className="col-12">
          <h3 className="text-center my-3 heading">New Contract Offer</h3>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        <div className="col-12 col-md-6 text-center">
        <img src={contract.team.image || placeholderImage} alt="Team Logo" className="img-fluid" style={{ maxHeight: '200px' }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center d-flex flex-column align-items-center my-2">
          <h5>{contract.team.manager}</h5>
          <h4>{contract.team.name}</h4>
          <p>{contract.seasonsRemaining} seasons</p>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-6 col-sm-4">
          <button onClick={acceptContract} className="btn btn-success w-100 m-1">ACCEPT</button>
        </div>
        <div className="col-6 col-sm-4">
          <button onClick={rejectContract} className="btn btn-danger w-100 m-1">REJECT</button>
        </div>
      </div>
    </div>
  );
};

export default AcceptContractForm;
